define('models/conversation/message',[
    'underscore', 'backbone', 'moment', 'utils',
    // services
    'services/api',
    // collections
    'collections/conversation/messages'
], function(
    _, Backbone, moment, U,
    // services
    API,
    // collections
    CMessages
) {

    var MMessage = Backbone.Epoxy.Model.extend({
        idAttribute: '_id',
        blacklist: ['date', 'attachments'],
        urlRoot: API.url('conversations/'),
        defaults: {
            content: "",
            replies: [],
            parentId: "",
        },

        setAttachment: function(file) {
            this.set('attachments', file);
        },

        getAttachments: function() {
            return this.get('attachments');
        },

        getTimeStampObject: function() {
            return moment(this.get('date'), API.format.timestamp);
        },

        getUser: function() {
            return this.get('user');
        },

        getReplies: function(opt) {
            opt = opt || {};
            return opt.collection ? new CMessages(this.get('replies')) : this.get('replies');
        },

        getLastReply: function() {
            return _.last(this.getReplies());
        },

        getActivity: function() {
            return this.get('activity');
        },

        getType: function() {
            return this.get('type');
        },

        getContent: function() {
            return this.get('message');
        },

        getTypeReference: function() {
            return this.get('typeRef');
        },

        isQuestionnaireResponse: function() {
            return this.getType() === 'questionnaireResponse';
        },
        // This function is to format the attachment correctly - notes use attachment in singular while messages use attachments in plural 
        addAttachment: function(file) {
            return { attachments: file }
        }
    });

    return MMessage;
});

